import styled from 'styled-components';

import {colors, font} from 'theme';

export const LabelText = styled.div`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    color: #939aa4;
`;

export const CustomInputLabelWrapper = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
export const CustomInputLabel = styled.label<{noMargin?: boolean}>`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    min-height: 44px;
    padding: 0 12px 0 0;
    margin-bottom: ${(p) => (p.noMargin ? '0' : '10px')};
    border: 1px solid ${colors.textMuted};
    border-radius: 8px;
`;

export const CustomInput = styled.input`
    box-sizing: border-box;
    padding: 0 16px;
    width: 100%;
    outline: 0;
    border: 0;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textPrimary};
    &::placeholder {
        font-family: ${font.family.primary};
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: ${colors.textSecondary};
    }
`;

export const LabelIcon = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.1322 14.3127C11.9262 15.2646 10.4031 15.8327 8.7474 15.8327C4.83538 15.8327 1.66406 12.6614 1.66406 8.74935C1.66406 4.83733 4.83538 1.66602 8.7474 1.66602C12.6594 1.66602 15.8307 4.83733 15.8307 8.74935C15.8307 10.4051 15.2626 11.9281 14.3108 13.1342L18.5033 17.3268C18.8288 17.6522 18.8288 18.1798 18.5033 18.5053C18.1779 18.8307 17.6502 18.8307 17.3248 18.5053L13.1322 14.3127ZM14.1641 8.74935C14.1641 11.7409 11.7389 14.166 8.7474 14.166C5.75585 14.166 3.33073 11.7409 3.33073 8.74935C3.33073 5.75781 5.75585 3.33268 8.7474 3.33268C11.7389 3.33268 14.1641 5.75781 14.1641 8.74935Z' fill='%23939AA4'/%3E%3C/svg%3E");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;
